import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Check, Phone, Award, Settings, Snowflake, Users, Building } from 'lucide-react';
import { services, contactInfo } from '../mockData';

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const service = services.find(s => s.id === serviceId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceId]);

  if (!service) {
    return (
      <div className="page-not-found">
        <div className="container">
          <h1>Hizmet Bulunamadı</h1>
          <button className="btn btn-primary" onClick={() => navigate('/hizmetlerimiz')}>
            Hizmetlere Dön
          </button>
        </div>
      </div>
    );
  }

  // Static content for each service
  const subtitle = serviceId === 'okul-servisi' 
    ? 'Öğrenci güvenliği öncelikli, disiplinli okul taşımacılığı'
    : serviceId === 'personel-tasimaciligi'
    ? 'Kurumsal firmalar için profesyonel personel servisi'
    : 'Güvenli ve konforlu taşımacılık hizmeti';

  const badges = [
    'Belgeli ve deneyimli şoförler',
    'Düzenli araç bakımı',
    'Erzurum kış şartlarına uygun donanım'
  ];

  const offerings = [
    'Sabah ve akşam olmak üzere günde 2 sefer düzenli servis',
    'Öğrenci velileriyle sürekli iletişim ve bilgilendirme',
    'GPS takip sistemi ile anlık konum bilgisi',
    'Okul kapısına kadar güvenli teslimat',
    'Öğrenci yoklama ve devam takibi',
    'Acil durum iletişim protokolü'
  ];

  const audiences = [
    { title: 'İlkokul Öğrencileri', desc: '6-10 yaş grubu için güvenli taşıma' },
    { title: 'Ortaokul Öğrencileri', desc: '11-14 yaş grubu için servis hizmeti' },
    { title: 'Lise Öğrencileri', desc: '15-18 yaş grubu için güzergâh seçenekleri' },
    { title: 'Özel Okullar', desc: 'Kurumsal anlaşmalar ve toplu taşıma' }
  ];

  return (
    <div className="page-service-detail">
      {/* Hero */}
      <section className="service-detail-hero">
        <div className="service-hero-bg">
          <img src={service.image} alt={service.title} />
          <div className="service-hero-overlay"></div>
        </div>
        <div className="container">
          <button className="back-btn" onClick={() => navigate('/hizmetlerimiz')}>
            <ArrowLeft size={18} />
            Geri
          </button>
          <div className="service-hero-content">
            <h1>{service.title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </section>

      {/* Badges */}
      <section className="service-badges-section">
        <div className="container">
          <div className="service-badges">
            <div className="service-badge">
              <div className="service-badge-icon"><Award size={20} /></div>
              <span>{badges[0]}</span>
            </div>
            <div className="service-badge">
              <div className="service-badge-icon"><Settings size={20} /></div>
              <span>{badges[1]}</span>
            </div>
            <div className="service-badge">
              <div className="service-badge-icon"><Snowflake size={20} /></div>
              <span>{badges[2]}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Offerings */}
      <section className="section service-offerings">
        <div className="container">
          <h2 className="section-title">Bu hizmet kapsamında neler sunuyoruz?</h2>
          <div className="offerings-list">
            <div className="offering-item">
              <div className="offering-check"><Check size={16} /></div>
              <span>{offerings[0]}</span>
            </div>
            <div className="offering-item">
              <div className="offering-check"><Check size={16} /></div>
              <span>{offerings[1]}</span>
            </div>
            <div className="offering-item">
              <div className="offering-check"><Check size={16} /></div>
              <span>{offerings[2]}</span>
            </div>
            <div className="offering-item">
              <div className="offering-check"><Check size={16} /></div>
              <span>{offerings[3]}</span>
            </div>
            <div className="offering-item">
              <div className="offering-check"><Check size={16} /></div>
              <span>{offerings[4]}</span>
            </div>
            <div className="offering-item">
              <div className="offering-check"><Check size={16} /></div>
              <span>{offerings[5]}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Audience */}
      <section className="section section-alt service-audience">
        <div className="container">
          <h2 className="section-title">Kimler için uygundur?</h2>
          <div className="audience-grid">
            <div className="audience-card">
              <div className="audience-icon"><Users size={24} /></div>
              <h3>{audiences[0].title}</h3>
              <p>{audiences[0].desc}</p>
            </div>
            <div className="audience-card">
              <div className="audience-icon"><Users size={24} /></div>
              <h3>{audiences[1].title}</h3>
              <p>{audiences[1].desc}</p>
            </div>
            <div className="audience-card">
              <div className="audience-icon"><Users size={24} /></div>
              <h3>{audiences[2].title}</h3>
              <p>{audiences[2].desc}</p>
            </div>
            <div className="audience-card">
              <div className="audience-icon"><Building size={24} /></div>
              <h3>{audiences[3].title}</h3>
              <p>{audiences[3].desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content">
            <h2>Bu hizmet hakkında fiyat ve detay almak ister misiniz?</h2>
            <p>Size özel teklif için hemen iletişime geçin</p>
            <div className="service-cta-buttons">
              <a 
                href="https://wa.me/905411492525" 
                className="btn btn-whatsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                WhatsApp'tan Yaz
              </a>
              <a href={`tel:${contactInfo.phone}`} className="btn btn-secondary">
                <Phone size={20} />
                Hemen Ara
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Other Services */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Diğer Hizmetlerimiz</h2>
          <div className="other-services-grid">
            {services.filter(s => s.id !== serviceId).slice(0, 3).map((s) => (
              <div 
                key={s.id} 
                className="other-service-card"
                onClick={() => navigate(`/hizmet/${s.id}`)}
              >
                <div className="other-service-image">
                  <img src={s.image} alt={s.title} />
                </div>
                <h4>{s.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
